import React from 'react'
import './UiService.css'
// import Testimonials from './Testimonials/Testimonials'
import Uifooter from './UiFooter/Uifooter'
import Industries from './Industries/Industries'
import Process from './Processs/Process'
import Heroui from './Heroui/Heroui'
import Whatwedo from './Whatwedo/Whatwedo'
import Aboutui from './Aboutui/Aboutui'
import Whyui from './Whyui/Whyui'
function UiService() {
  return (
    <div id='uiuxservice'>
      <Heroui />
      <Aboutui />
      <Whatwedo />
      <Whyui />
      <Process />
      <Industries />
      <Uifooter />
    </div>
  )
}

export default UiService